import { RootState } from '../../store';

export const getAssetsState = (state: RootState) => state.assetsState.assets;
export const assetTaskHistorySelector = (state: RootState) =>
  state.assetsState.taskHistory;
